import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DynamicResidentialProxy from '../views/DynamicResidentialProxy.vue'
import StaticResidentialProxy from '../views/StaticResidentialProxy.vue'
import HelpCenter from '../views/HelpCenter.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dynamic-residential-proxy',
    name: 'DynamicResidentialProxy',
    component: DynamicResidentialProxy
  },
  {
    path: '/static-residential-proxy',
    name: 'StaticResidentialProxy',
    component: StaticResidentialProxy
  },
  {
    path: '/help-center',
    name: 'HelpCenter',
    component: HelpCenter
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/auth',
    children: [
      {
        path: 'auth',
        name: 'Auth',
        component: () => import('../views/dashboard/auth/index.vue')
      },
      {
        path: 'subaccount',
        name: 'Subaccount',
        component: () => import('../views/dashboard/auth/subaccount/index.vue')
      },
      {
        path: 'traffic',
        name: 'Traffic',
        component: () => import('../views/dashboard/auth/traffic/index.vue')
      },
      {
        path: 'purchase',
        name: 'Purchase',
        component: () => import('../views/purchase/Index.vue')
      }
    ]
  },
  {
    path: '/record',
    component: Layout,
    redirect: '/record/flow-change',
    children: [
      {
        path: 'flow-change',
        name: 'FlowChangeRecord',
        component: () => import('../views/record/flowchangerecord.vue')
      },
      {
        path: 'login',
        name: 'LoginRecord',
        component: () => import('../views/record/loginrecord.vue')
      }
    ]
  },
  {
    path: '/check',
    component: Layout,
    redirect: '/check/proxy',
    children: [
      {
        path: 'proxy',
        name: 'ProxyCheck',
        component: () => import('../views/check/index.vue')
      }
    ]
  },
  {
    path: '/static',
    component: Layout,
    redirect: '/static/list',
    children: [
      {
        path: 'list',
        name: 'StaticList',
        component: () => import('../views/static/Index.vue')
      },
      {
        path: 'purchase',
        name: 'StaticPurchase',
        component: () => import('../views/static/Purchase.vue')
      },
      // {
      //   path: 'broadcast-purchase',
      //   name: 'BroadcastPurchase',
      //   component: () => import('../views/static/BroadcastPurchase.vue')
      // }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/profile',
    children: [
      {
        path: 'profile',
        name: 'PersonalCenter',
        component: () => import('../views/user/index.vue')
      },
      // {
      //   path: 'dynamic-api',
      //   name: 'DynamicApi',
      //   component: () => import('../views/user/DynamicApi.vue')
      // }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
